let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2hmR6")).then(() => parcelRequire('59W6U'));